@if (searchService.error()) {
  <div
    class="absolute w-full bottom-0 flex items-start gap-sm border-b border-red-60 bg-red-20 px-2xl py-sm"
  >
    <svg-icon
      src="icon_error_20px.svg"
      class="mt-3xs shrink-0"
      svgClass="w-xl h-xl fill-red-110"
    ></svg-icon>
    <div>
      <p class="font-body text-sm font-semibold leading-md text-red-120">Σφάλμα αναζήτησης</p>
      <p class="font-body text-sm font-medium leading-md text-red-110">
        {{ searchService.error() }}
      </p>
    </div>
  </div>
}

@if (searchService.initalizationFailed()) {
  <div
    class="absolute w-full top-0 flex items-start gap-sm border-b border-red-60 bg-red-20 px-2xl py-sm"
  >
    <svg-icon
      src="icon_error_20px.svg"
      class="mt-3xs shrink-0"
      svgClass="w-xl h-xl fill-red-110"
    ></svg-icon>
    <div>
      <p class="font-body text-sm font-semibold leading-md text-red-120">
        Αποτυχία σύνδεσης με τη μηχανή αναζήτησης
      </p>
      <p class="font-body text-sm font-medium leading-md text-red-110">
        Παρακαλώ ανανεώστε τη σελίδα. Αν το πρόβλημα συνεχίζεται, δοκιμάστε ξανά αργότερα.
      </p>
    </div>
  </div>
}

@if (!hasSearched()) {
  <!-- ── Landing: hero + full form, vertically centered ── -->
  <div class="flex min-h-screen flex-col items-center justify-center bg-grey-30 px-md py-4xl">
    <!-- Hero -->
    <div class="mb-3xl text-center">
      <h1
        class="font-heading text-4xl font-bold leading-4xl text-grey-120 select-none cursor-default"
        (click)="headerTapCount.update(n => n + 1)"
      >Αναζήτηση ακινήτων</h1>
      <p class="mt-xs font-body text-md font-medium leading-xl text-grey-100">
        Αναζητήστε ακίνητα προς πώληση στην περιοχή που σας ενδιαφέρει
      </p>
      @if (showClientId()) {
        <div class="mt-sm inline-flex items-center gap-xs rounded-md border border-grey-40 bg-white px-sm py-2xs">
          <span class="font-body text-xs font-medium text-grey-80">ID:</span>
          <span class="relative">
            <span
              class="cursor-pointer font-mono text-xs text-grey-110"
              (click)="copyClientId()"
            >{{ userService.clientId() }}</span>
            @if (clientIdCopied()) {
              <span class="absolute -top-7 left-1/2 -translate-x-1/2 rounded bg-grey-110 px-xs py-3xs font-body text-2xs font-medium text-white whitespace-nowrap">
                Copied!
              </span>
            }
          </span>
        </div>
      }
    </div>

    <!-- Realtors -->
    <div class="mb-2xl flex flex-wrap items-center justify-center gap-sm">
      <span class="font-body text-xs font-medium leading-sm text-grey-90"
        >Η αναζήτηση πραγματοποιείται στα εξής μεσιτικά:</span
      >
      <a
        href="https://bee-realestate.gr/"
        target="_blank"
        rel="noopener noreferrer"
        class="rounded-max border border-grey-50 bg-white px-sm py-2xs font-body text-xs font-semibold leading-sm text-grey-110 transition-colors hover:border-grey-80 hover:text-grey-120"
      >
        Bee Real Estate
      </a>
      <a
        href="https://goldenhome.gr/"
        target="_blank"
        rel="noopener noreferrer"
        class="rounded-max border border-grey-50 bg-white px-sm py-2xs font-body text-xs font-semibold leading-sm text-grey-110 transition-colors hover:border-grey-80 hover:text-grey-120"
      >
        Golden Home
      </a>
      <a
        href="https://marketplace.altamiraproperties.gr/"
        target="_blank"
        rel="noopener noreferrer"
        class="rounded-max border border-grey-50 bg-white px-sm py-2xs font-body text-xs font-semibold leading-sm text-grey-110 transition-colors hover:border-grey-80 hover:text-grey-120"
      >
        Altamira
      </a>
      <a
        href="https://www.remax-choice.gr/"
        target="_blank"
        rel="noopener noreferrer"
        class="rounded-max border border-grey-50 bg-white px-sm py-2xs font-body text-xs font-semibold leading-sm text-grey-110 transition-colors hover:border-grey-80 hover:text-grey-120"
      >
        Remax Choice
      </a>
    </div>

    <!-- Full form card -->
    <div class="w-full max-w-2xl rounded-lg bg-white p-3xl shadow-sm">
      <!-- Area -->
      <div class="mb-2xl">
        <p class="mb-1.5 font-heading text-sm font-semibold leading-md text-grey-110">
          Περιοχή <span class="text-red-90">*</span>
        </p>
        <app-dropdown
          type="search-bar"
          [sections]="dropdownSections"
          [formGroup]="searchForm"
          [controlName]="'areaId'"
          placeholder="Αναζητήστε περιοχή"
          helper="Εισάγετε τουλάχιστον 3 χαρακτήρες"
        ></app-dropdown>
        @if (areaInvalid) {
          <p class="px-sm pt-3xs font-body text-xs font-medium text-red-120">
            Παρακαλώ επιλέξτε περιοχή
          </p>
        }
      </div>

      <!-- Divider -->
      <div class="mb-2xl border-t border-grey-40"></div>

      <!-- Price -->
      <div class="mb-2xl">
        <p class="mb-sm font-heading text-sm font-semibold leading-md text-grey-110">Τιμή</p>
        <div class="grid grid-cols-2 gap-lg">
          <app-generic-input-field
            [formGroup]="searchForm"
            controlName="priceMin"
            placeholder="πχ 800000"
            amountModifier="€"
            [showValidationTemplates]="true"
            [errorMessage]="priceMinError"
            successMessage=""
          ></app-generic-input-field>
          <app-generic-input-field
            [formGroup]="searchForm"
            controlName="priceMax"
            placeholder="πχ 1200000"
            amountModifier="€"
            [showValidationTemplates]="true"
            [errorMessage]="priceMaxError"
            successMessage=""
          ></app-generic-input-field>
        </div>
      </div>

      <!-- Divider -->
      <div class="mb-2xl border-t border-grey-40"></div>

      <!-- Size -->
      <div class="mb-2xl">
        <p class="mb-sm font-heading text-sm font-semibold leading-md text-grey-110">Εμβαδόν</p>
        <div class="grid grid-cols-2 gap-lg">
          <app-generic-input-field
            [formGroup]="searchForm"
            controlName="sizeMin"
            placeholder="πχ 60"
            amountModifier="τμ"
            [showValidationTemplates]="true"
            [errorMessage]="sizeMinError"
            successMessage=""
          ></app-generic-input-field>
          <app-generic-input-field
            [formGroup]="searchForm"
            controlName="sizeMax"
            placeholder="πχ 80"
            amountModifier="τμ"
            [showValidationTemplates]="true"
            [errorMessage]="sizeMaxError"
            successMessage=""
          ></app-generic-input-field>
        </div>
      </div>

      <!-- Divider -->
      <div class="mb-2xl border-t border-grey-40"></div>

      <div class="mb-3xl">
        <p class="mb-1.5 font-heading text-sm font-semibold leading-md text-grey-110">
          Πλειστηριασμοί
        </p>
        <app-dropdown
          [sections]="auctionSections"
          [formGroup]="searchForm"
          [controlName]="'auction'"
          placeholder="Όχι"
        ></app-dropdown>
      </div>

      <app-regular-button
        [label]="
          searchService.isLoadingMore() || searchService.isTyping() ? 'Διακοπή' : 'Αναζήτηση'
        "
        [fullWidth]="true"
        (buttonClicked)="onClick()"
        [disabled]="searchService.initalizationFailed()"
      >
      </app-regular-button>
    </div>
  </div>
}

@if (hasSearched()) {
  <!-- ── Active: sticky bars + scrollable results ── -->
  <div class="flex min-h-screen flex-col bg-grey-30">
    <!-- Single sticky wrapper — both rows stick together -->
    <div class="sticky top-0 z-20 shadow-sm">
      <!-- Form bar -->
      <div class="border-b border-grey-50 bg-white">
        <div class="mx-auto w-full max-w-6xl px-lg py-sm">
          <!-- Row 1: Area + (price/size on md+) + button -->
          <div class="flex items-start gap-sm">
            <!-- Area -->
            <div class="flex min-w-0 flex-1 flex-col pt-1">
              <span class="font-body text-2xs font-semibold leading-xs text-grey-90">
                Περιοχή <span class="text-red-90">*</span>
              </span>
              <app-dropdown
                type="search-bar"
                size="small"
                [sections]="dropdownSections"
                [formGroup]="searchForm"
                [controlName]="'areaId'"
                placeholder="Αναζητήστε περιοχή"
              ></app-dropdown>
              @if (areaInvalid) {
                <p class="px-3xs font-body text-2xs font-medium text-red-120">
                  Παρακαλώ επιλέξτε περιοχή
                </p>
              }
            </div>

            <!-- Price (md+ only) -->
            <div class="hidden w-px self-stretch bg-grey-50 lg:block"></div>
            <div class="hidden flex-col gap-3xs p-3xs lg:flex">
              <span class="font-body text-2xs font-semibold leading-xs text-grey-90">Τιμή</span>
              <div class="flex items-start gap-2xs">
                <div class="w-28">
                  <app-generic-input-field
                    [formGroup]="searchForm"
                    controlName="priceMin"
                    size="small"
                    placeholder="Από"
                    amountModifier="€"
                    [showValidationTemplates]="true"
                    [errorMessage]="priceMinError"
                    successMessage=""
                  ></app-generic-input-field>
                </div>
                <span class="shrink-0 pt-2xs font-body text-sm text-grey-80">–</span>
                <div class="w-28">
                  <app-generic-input-field
                    [formGroup]="searchForm"
                    controlName="priceMax"
                    size="small"
                    placeholder="Έως"
                    amountModifier="€"
                    [showValidationTemplates]="true"
                    [errorMessage]="priceMaxError"
                    successMessage=""
                  ></app-generic-input-field>
                </div>
              </div>
            </div>

            <!-- Size (md+ only) -->
            <div class="hidden w-px self-stretch bg-grey-50 lg:block"></div>
            <div class="hidden flex-col gap-3xs p-3xs lg:flex">
              <span class="font-body text-2xs font-semibold leading-xs text-grey-90">Εμβαδόν</span>
              <div class="flex items-start gap-2xs">
                <div class="w-24">
                  <app-generic-input-field
                    [formGroup]="searchForm"
                    controlName="sizeMin"
                    size="small"
                    placeholder="Από"
                    amountModifier="τμ"
                    [showValidationTemplates]="true"
                    [errorMessage]="sizeMinError"
                    successMessage=""
                  ></app-generic-input-field>
                </div>
                <span class="shrink-0 pt-2xs font-body text-sm text-grey-80">–</span>
                <div class="w-24">
                  <app-generic-input-field
                    [formGroup]="searchForm"
                    controlName="sizeMax"
                    size="small"
                    placeholder="Έως"
                    amountModifier="τμ"
                    [showValidationTemplates]="true"
                    [errorMessage]="sizeMaxError"
                    successMessage=""
                  ></app-generic-input-field>
                </div>
              </div>
            </div>

            <div class="hidden w-px self-stretch bg-grey-50 lg:block"></div>

            <div class="hidden w-24 flex-col pt-1 lg:flex">
              <span class="font-body text-2xs font-semibold leading-xs text-grey-90">
                Πλειστηριασμοί
              </span>
              <app-dropdown
                size="small"
                [sections]="auctionSections"
                [formGroup]="searchForm"
                [controlName]="'auction'"
                placeholder="Όχι"
              ></app-dropdown>
            </div>

            <div class="hidden w-px self-stretch bg-grey-50 lg:block"></div>

            <div class="flex flex-col gap-3xs p-3xs">
              <span
                class="font-body text-2xs font-semibold leading-xs text-transparent select-none"
              >
                &nbsp;
              </span>
              <app-regular-button
                [label]="
                  searchService.isLoadingMore() || searchService.isTyping()
                    ? 'Διακοπή'
                    : 'Αναζήτηση'
                "
                size="small"
                (buttonClicked)="onClick()"
              ></app-regular-button>
            </div>
          </div>

          <!-- Row 2: Price + Size (mobile only) -->
          <div class="mt-xs flex items-start gap-sm lg:hidden">
            <div class="flex flex-1 flex-col gap-3xs">
              <span class="font-body text-2xs font-semibold leading-xs text-grey-90">Τιμή</span>
              <div class="flex items-center gap-2xs">
                <div class="min-w-0 flex-1">
                  <app-generic-input-field
                    [formGroup]="searchForm"
                    controlName="priceMin"
                    size="small"
                    placeholder="Από"
                    amountModifier="€"
                    [showValidationTemplates]="true"
                    [errorMessage]="priceMinError"
                    successMessage=""
                  ></app-generic-input-field>
                </div>
                <span class="shrink-0 font-body text-sm text-grey-80">–</span>
                <div class="min-w-0 flex-1">
                  <app-generic-input-field
                    [formGroup]="searchForm"
                    controlName="priceMax"
                    size="small"
                    placeholder="Έως"
                    amountModifier="€"
                    [showValidationTemplates]="true"
                    [errorMessage]="priceMaxError"
                    successMessage=""
                  ></app-generic-input-field>
                </div>
              </div>
            </div>
            <div class="flex flex-1 flex-col gap-3xs">
              <span class="font-body text-2xs font-semibold leading-xs text-grey-90">Εμβαδόν</span>
              <div class="flex items-center gap-2xs">
                <div class="min-w-0 flex-1">
                  <app-generic-input-field
                    [formGroup]="searchForm"
                    controlName="sizeMin"
                    size="small"
                    placeholder="Από"
                    amountModifier="τμ"
                    [showValidationTemplates]="true"
                    [errorMessage]="sizeMinError"
                    successMessage=""
                  ></app-generic-input-field>
                </div>
                <span class="shrink-0 font-body text-sm text-grey-80">–</span>
                <div class="min-w-0 flex-1">
                  <app-generic-input-field
                    [formGroup]="searchForm"
                    controlName="sizeMax"
                    size="small"
                    placeholder="Έως"
                    amountModifier="τμ"
                    [showValidationTemplates]="true"
                    [errorMessage]="sizeMaxError"
                    successMessage=""
                  ></app-generic-input-field>
                </div>
              </div>
            </div>
            <div class="hidden flex-1 flex-col gap-[1px] max-w-[20%] sm:flex lg:hidden">
              <span class="font-body text-2xs font-semibold leading-xs text-grey-90">
                Πλειστηριασμοί
              </span>
              <app-dropdown
                size="small"
                [sections]="auctionSections"
                [formGroup]="searchForm"
                [controlName]="'auction'"
                placeholder="Όχι"
              ></app-dropdown>
            </div>
          </div>

          <div class="mt-3 flex flex-col max-w-[23%] gap-3xs sm:hidden">
            <span class="font-body text-2xs font-semibold leading-xs text-grey-90">
              Πλειστηριασμοί
            </span>
            <app-dropdown
              size="small"
              [sections]="auctionSections"
              [formGroup]="searchForm"
              [controlName]="'auction'"
              placeholder="Όχι"
            ></app-dropdown>
          </div>
        </div>
      </div>

      <!-- Count / streaming row -->
      <div class="border-b border-grey-40 bg-grey-20">
        <div class="mx-auto flex max-w-6xl items-center justify-between px-2xl py-xs">
          <p class="font-heading text-sm font-semibold leading-md text-grey-120">
            {{ resultsService.listings().length }}
            {{ resultsService.listings().length === 1 ? 'αποτέλεσμα' : 'αποτελέσματα' }}
          </p>
          @if (searchService.isTyping() || searchService.isLoadingMore()) {
            <div class="flex items-center gap-2xs">
              <span class="relative flex h-2 w-2">
                <span
                  class="absolute inline-flex h-full w-full animate-ping rounded-full bg-navy-blue-90 opacity-75"
                ></span>
                <span class="relative inline-flex h-2 w-2 rounded-full bg-navy-blue-90"></span>
              </span>
              <span class="font-body text-xs font-bold leading-sm text-grey-90"
                >Ανακτώνται αποτελέσματα</span
              >
            </div>
          }
        </div>
      </div>
    </div>

    <!-- Scrollable results -->
    <div class="mx-auto w-full max-w-7xl flex-1 px-2xl py-2xl">
      <app-results-grid />
    </div>
  </div>
}
